import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "zebra"];
import React from 'react';
import { bool, node, string } from 'prop-types';
import classNames from 'classnames';
import { TableRow as MuiTableRow } from '@material-ui/core';
import useTableRowStyles from './TableRow.styles';
function TableRow(props) {
  const {
      className,
      zebra
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const classes = useTableRowStyles({
    zebra
  });
  return /*#__PURE__*/React.createElement(MuiTableRow, Object.assign({}, otherProps, {
    className: classNames('pds-table__row', className),
    classes: classes
  }));
}
TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: node,
  /**
   * @ignore
   */
  className: string,
  /**
   * If `true`, the table row will shade on hover.
   */
  hover: bool,
  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: bool,
  /**
   * If `true`, the table row will have zebra shading if row number is odd.
   */
  zebra: bool
};
export default TableRow;